import page_sections_collector from "page_sections_collector"
import {Controller} from "@hotwired/stimulus"
import viewport_helper from "viewport_helper"
import {createRoot} from "react-dom/client"
import {update_icon} from "../dom_utils"
import PageMenu from "page_menu"
import signals from "signals"
import React from "react"

class SidebarController extends Controller {
  static targets = [
    "sidebar",
    "pageMenu",
    "sidebarToggle",
    "ebookPromotion",
    "mobileMiddlebarTitle"
  ]

  connect() {
    page_sections_collector.init()
    this.init_mobile_middlebar_title()
    this.init_page_menu()
    signals.on("kenhub.filterbar_opened", () => this.close_mobile_sidebar())
    // on mobile we want to close the side bar when a page menu entry was clicked
    // because it covers most of the screen
    signals.on("kenhub.viewport_changed", () => this.close_mobile_sidebar())
  }

  init_page_menu() {
    if (!this.hasPageMenuTarget) return

    const root = createRoot(this.pageMenuTarget)
    page_sections_collector.register((page_sections) => {
      root.render(
        <PageMenu
          menu_entries={page_sections}
          on_menu_entry_clicked={(section_id) =>
            viewport_helper.go_to(`#${section_id}`)
          }
        />
      )
    })
  }

  init_mobile_middlebar_title() {
    if (!this.hasMobileMiddlebarTitleTarget) return

    const initial_mobile_middlebar_title =
      this.mobileMiddlebarTitleTarget.innerHTML
    page_sections_collector.register((_, active_section) => {
      if (active_section) {
        this.mobileMiddlebarTitleTarget.innerHTML = active_section.title
      } else {
        this.mobileMiddlebarTitleTarget.innerHTML =
          initial_mobile_middlebar_title
      }
    })
  }

  show_ebook_promotion() {
    this.ebookPromotionTarget.classList.add("ebook-promotion--visible")
  }

  toggle_mobile_sidebar(event) {
    if (this.sidebarTarget.classList.contains("extended")) {
      this.close_mobile_sidebar(event)
    } else {
      this.open_mobile_sidebar(event)
    }
  }

  open_mobile_sidebar() {
    this.sidebarTarget.classList.add("extended")
    this.sidebarToggleTarget.classList.add("extended")
    const icon = this.sidebarToggleTarget.querySelector("i")
    icon.classList.remove("gray")
    const svg = icon.querySelector("svg")
    update_icon(svg, "fa-chevron-up")
    signals.emit("kenhub.sidebar_opened")
  }

  close_mobile_sidebar() {
    if (!this.hasSidebarTarget) return

    this.sidebarTarget.classList.remove("extended")
    this.sidebarToggleTarget.classList.remove("extended")
    const icon = this.sidebarToggleTarget.querySelector("i")
    icon.classList.add("gray")
    const svg = icon.querySelector("svg")
    update_icon(svg, "fa-chevron-down")
  }
}

export default SidebarController
